import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ca9c4f8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CalMainCarousel: require('/app/components/cal-main-carousel.vue').default,CalProductTileList: require('/app/components/cal-product-tile-list.vue').default,CalSkeletonProductList: require('/app/components/cal-skeleton-product-list.vue').default,CalCardSection: require('/app/components/cal-card-section.vue').default,CalCenterHeading: require('/app/components/cal-center-heading.vue').default,CalMomentSection: require('/app/components/cal-moment-section.vue').default,CalPopUpBanner: require('/app/components/cal-pop-up-banner.vue').default})
